import gql from 'graphql-tag'

export const DEFAULT_IMPORT_VALUES = {
  file: '',
    imported: false,
  }

export const fragments = {
  import: gql`
    fragment importFields on Import {
      id
      file
      imported
      updatedAt
      createdAt
    }
  `
}

export const GET_ALL_IMPORTS_QUERY = gql`
  query imports($page: Int) {
    imports(page: $page, limit: 10) {
      collection {
        ...importFields
      }
      metadata {
        totalPages
        totalCount
        currentPage
        limitValue
      }
    }
  }
  ${fragments.import}
`

export const GET_IMPORT_QUERY = gql`
  query import($id: Int!) {
    import(id: $id) {
      ...importFields
    }
  }
  ${fragments.import}
`

export const CREATE_IMPORT_MUTATION = gql`
  mutation createImport($import: ImportInput!) {
    import: createImport(import: $import) {
      ...importFields
    }
  }
  ${fragments.import}
`

export const UPDATE_IMPORT_MUTATION = gql`
  mutation updateImport($id: Int!, $import: ImportInput!) {
    import: updateImport(id: $id, import: $import) {
      ...importFields
    }
  }
  ${fragments.import}
`

export const DELETE_IMPORT_MUTATION = gql`
  mutation deleteImport($ids: [Int!]!) {
    import: deleteImport(ids: $ids) {
      ...importFields
    }
  }
  ${fragments.import}
`

export const EXPORT_MUTATION = gql`
  mutation export($format: String!) {
    export: export(format: $format) {
      fileName
      contentType
      fileContents
    }
  }
`
